/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const Stats: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="stats" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M113.3333333333333 170V283.3333333333335H1246.6666666666665V170H113.3333333333333zM226.6666666666667 396.6666666666668V680H340V396.6666666666668H226.6666666666667zM510 396.6666666666668V906.6666666666669H623.3333333333333V396.6666666666668H510zM793.3333333333333 396.6666666666668V1190H906.6666666666666V396.6666666666668H793.3333333333333zM1076.6666666666665 396.6666666666668V906.6666666666669H1190V396.6666666666668H1076.6666666666665z" : "M90.6666666666667 136V226.6666666666667H997.3333333333334V136H90.6666666666667zM181.3333333333334 317.3333333333333V544H272V317.3333333333333H181.3333333333334zM408 317.3333333333333V725.3333333333333H498.6666666666667V317.3333333333333H408zM634.6666666666667 317.3333333333333V952H725.3333333333334V317.3333333333333H634.6666666666667zM861.3333333333334 317.3333333333333V725.3333333333333H952V317.3333333333333H861.3333333333334z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
Stats.displayName = `Blueprint5.Icon.Stats`;
export default Stats;
